import { Injectable } from '@angular/core';
import * as OT from '@opentok/client';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { environment } from 'src/environments/environment';

@Injectable()
export class TokboxService {
    session: OT.Session;
    token: string;
    SESSION_ID: string; // = '2_MX40NjI1NTE0Mn5-MTU0OTk3NjY5NTY2NX51Q3RwUUZzd3NtUmF1WnRidW5KTmpxOWR-UH4';
    private videoApiUrl = environment.apibaseUrl + '/video/';

    constructor(private http: HttpClient) { }

    getOT() {
        return OT;
    }

    public getToken(sessionId): Observable<any> {
        this.SESSION_ID = sessionId;
        return this.http.get(this.videoApiUrl + 'Tookboxtoken?sessionId=' + encodeURIComponent(sessionId));
    }


    initSession(token) {
        this.session = this.getOT().initSession(environment.tokboxApiKey, this.SESSION_ID);
        this.token = token;
        return Promise.resolve(this.session);
    }

    connect() {
        return new Promise((resolve, reject) => {
            this.session.connect(this.token, (err) => {
                if (err) {
                    reject(err);
                } else {
                    resolve(this.session);
                }
            });
        });
    }

    disconnect() {
        if (this.session) {
            this.session.disconnect();
        }
    }

    leave(stream) {
        if (this.session) {
            return new Promise((resolve, reject) => {
                this.session.forceUnpublish(stream, (err) => {
                    if (err) {
                        reject(err);
                    } else {
                        resolve(this.session);
                    }
                });
            });
        }
    }
}
